import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { GraduationCap, Compass, CalendarDays, X } from "lucide-react";
import { RegalChat } from "./RegalChat";

const MODES = [
  { to: "/education", icon: GraduationCap, title: "Teach Me", testid: "advisor-teach" },
  { to: "/finder", icon: Compass, title: "Choose", testid: "advisor-choose" },
  { to: "/book", icon: CalendarDays, title: "Advisor", testid: "advisor-connect" },
];

// Persistent "Ask Mr. Regal" — AI jewelry concierge chat, on every page
export const RegalAdvisor = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  React.useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("rj-open-chat", h);
    return () => window.removeEventListener("rj-open-chat", h);
  }, []);

  React.useEffect(() => {
    window.dispatchEvent(new CustomEvent("rj-chat-state", { detail: { open } }));
  }, [open]);
  if (pathname.startsWith("/admin")) return null;

  return (
    <div className="fixed bottom-4 left-3 sm:bottom-5 sm:left-4 z-40" data-testid="regal-advisor">
      {open && (
        <div
          className="absolute bottom-[68px] left-0 w-[calc(100vw-2.5rem)] max-w-[360px] bg-white border border-[#d8cdb5] shadow-[0_18px_50px_-18px_rgba(26,23,19,0.45)] flex flex-col"
          style={{ height: "min(540px, calc(100vh - 150px))" }}
          data-testid="advisor-panel"
        >
          <div className="flex items-center gap-3 px-4 py-3 border-b border-[#eee6d6] shrink-0">
            <img src="/mr-regal-welcome.webp" alt="" aria-hidden="true" className="h-10 w-8 object-cover object-top rounded-t-full border border-[#c9a24b]/50 bg-white" />
            <div className="min-w-0 flex-1">
              <p className="text-[10px] tracking-[0.3em] uppercase text-[#a8842c]">Ask Mr. Regal</p>
              <p className="text-[11px] text-[#8f8571] mt-0.5">Your personal jewelry concierge</p>
            </div>
            <button onClick={() => setOpen(false)} aria-label="Close chat" className="text-[#8f8571] hover:text-[#171310] p-1 transition-colors" data-testid="advisor-close-btn">
              <X size={16} />
            </button>
          </div>
          <div className="flex border-b border-[#eee6d6] shrink-0">
            {MODES.map(({ to, icon: Icon, title, testid }) => (
              <Link key={to} to={to} onClick={() => setOpen(false)} data-testid={testid}
                className="flex-1 flex items-center justify-center gap-1.5 py-2 text-[10px] tracking-[0.1em] uppercase whitespace-nowrap text-[#7a7160] hover:text-[#8a6a1f] hover:bg-[#faf5e8] transition-colors">
                <Icon size={12} className="text-[#a8842c] shrink-0" /> {title}
              </Link>
            ))}
          </div>
          <RegalChat />
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-label={open ? "Close Mr. Regal's chat" : "Ask Mr. Regal — chat with your jewelry concierge"}
        className="h-12 w-12 sm:h-14 sm:w-14 rounded-full bg-white border-2 border-[#c9a24b] shadow-[0_8px_24px_-8px_rgba(168,132,44,0.55)] overflow-hidden hover:scale-105 transition-transform duration-300 motion-reduce:transition-none"
        data-testid="advisor-btn"
      >
        {open ? (
          <span className="flex items-center justify-center h-full w-full text-[#8a6a1f]"><X size={20} /></span>
        ) : (
          <img src="/mr-regal-welcome.webp" alt="" aria-hidden="true" loading="lazy" decoding="async" className="h-full w-full object-cover object-top scale-[1.7] origin-top" />
        )}
      </button>
    </div>
  );
};
